export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'supportOnSocial', getter: () => import(/* webpackChunkName: "tiledItems" */ 'components/bolt/tiledItems/tiledItems'), component: 'tiledItems', parent: 'boltHome' },
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
